// extracted by mini-css-extract-plugin
export default {"instruction":"Advantages_instruction__7j-q2","blocks":"Advantages_blocks__aApy+","block":"Advantages_block__GE8ni"};